/**
 * FASE2-WIZARD-2b-bis — Texto de un rango sobre una escala ordinal.
 *
 * Fuente ÚNICA de la redacción. La usan el formulario del mandato (bajo la
 * barra, mientras se arrastra) y la ficha del anuncio.
 *
 * SE LEE LA COTA, NO LA ETIQUETA. Las etiquetas de tramo ya son rangos
 * ("2 – 5 años", "500.000 € – 1 M€"), así que anteponerles "Desde" producía
 * frases ambiguas: "Desde 2 – 5 años" se entiende como "de 2 a 5 años" cuando
 * significa "de 2 años en adelante". Usando los límites del tramo el texto
 * queda unívoco: "Desde 2 años", "Hasta 5 M€", "De 2 a 20 años".
 *
 * Cuatro variantes:
 *   - los dos topes en los extremos      → "Cualquiera"
 *   - solo el mínimo movido              → "Más de {cota inferior del tramo}"
 *   - solo el máximo movido              → "Hasta {cota superior del tramo}"
 *   - los dos acotados, o el mismo tramo → "De {inferior} a {superior}"
 *
 * El mínimo en el primer tramo equivale a "sin mínimo", así que se lee "Hasta
 * X" y nunca "De 0 a X".
 *
 * FASE2-SCHEMA-01.4: el extremo inferior pasa de "Desde X" a "Más de X". Los
 * sufijos de las claves (.desde / .hasta / .entre) describen la FORMA del
 * rango —abierto por abajo, por arriba, o cerrado— no el copy, así que no
 * cambian al cambiar el texto.
 */

/**
 * @param {Object} group grupo de MANDATO_RANGE_GROUPS (scale, messagePrefix, formatBound)
 * @param {number} min ordinal del extremo inferior
 * @param {number} max ordinal del extremo superior
 * @param {Object} intl
 * @returns {string|null} texto listo para mostrar, o null si faltan datos
 */
export const formatScaleRange = (group, min, max, intl) => {
  const { scale = [], messagePrefix, formatBound } = group || {};
  if (scale.length === 0 || min == null || max == null) {
    return null;
  }
  const first = scale[0].idx;
  const last = scale[scale.length - 1].idx;

  // Cubre la escala entera: no acota nada.
  if (min <= first && max >= last) {
    return intl.formatMessage({ id: 'ListingPage.mandato.cualquiera' });
  }

  const minTramo = scale.find(s => s.idx === min);
  const maxTramo = scale.find(s => s.idx === max);
  if (!minTramo || !maxTramo) {
    return null;
  }

  const sinMinimo = min <= first;
  // El último tramo es abierto por arriba (upperBound null): si el máximo cae
  // ahí, no hay cota superior que mostrar y el rango es "desde".
  const sinMaximo = max >= last || maxTramo.upperBound == null;

  const desde = formatBound(minTramo.lowerBound);
  const hasta = sinMaximo ? null : formatBound(maxTramo.upperBound);

  if (sinMinimo) {
    return intl.formatMessage({ id: `${messagePrefix}.hasta` }, { max: hasta });
  }
  if (sinMaximo) {
    return intl.formatMessage({ id: `${messagePrefix}.desde` }, { min: desde });
  }
  return intl.formatMessage({ id: `${messagePrefix}.entre` }, { min: desde, max: hasta });
};
